import React from 'react';
import { isEmpty, cloneDeep } from 'lodash';

import List from '@material-ui/core/List';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';
import DeleteOutlined from '@material-ui/icons/DeleteOutlined';
import CloseIcon from '@material-ui/icons/Close';
import Modal from '@material-ui/core/Modal';
// import FormControlLabel from '@material-ui/core/FormControlLabel';
// import Checkbox from '@material-ui/core/Checkbox';

import Route from '../planners/Route';
import ACButton from '../../atoms/ACButton';

import styles from './SetRouteBulkActions.module.scss';

export default class SetRouteBulkActions extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showAllPossibleRoutes: false,
    };

    this.onChangeShowAllRoutes = this.onChangeShowAllRoutes.bind(this);
  }

  onChangeShowAllRoutes() {
    let { showAllPossibleRoutes } = this.state;
    showAllPossibleRoutes = !showAllPossibleRoutes;
    this.setState({ showAllPossibleRoutes });
  }

  renderRoutes(routes) {
    if (!routes || isEmpty(routes)) return null;
    return (
      <List>
        {routes.map(route => (
          <Route key={route.id} route={route} onSelectRouteFunc={this.props.onSelectRouteFunc} />
        ))}
      </List>
    );
  }


  render() {
    let { routes = []} = cloneDeep(this.props);

    return (
      <Modal open={this.props.isModifying} onClose={this.props.onCloseFunc}>
        <div className={styles.root}>
          <div>
            <div className={styles.fullWidthColumn}>
              <div className={styles.top}>
                <div>
                  <h3>Add Route</h3>
                </div>
                <div>
                  <CloseIcon className={styles.pointerCursor} onClick={this.props.onCloseFunc} />
                </div>
              </div>
              <div>
                {' '}
                <ACButton
                  text={'Clear Booking Route'}
                  icon={<DeleteOutlined />}
                  iconLast={true}
                  onClickFunc={this.props.onClickClearBookingRouteFunc}
                  color="rgb(255, 118, 95)"
                />
              </div>
              <div className={styles.middle}>
                <div>Available Routes</div>
                <div>
                  <ACButton
                    text={'Create New'}
                    icon={<AddCircleOutlineIcon />}
                    iconLast={true}
                    onClickFunc={this.props.onClickAddNewRoute}
                  />
                </div>
              </div>
            </div>
            <div>
            </div>
            {/* <FormControlLabel
              control={
                <Checkbox
                  color="primary"
                  onChange={this.onChangeShowAllRoutes}
                  checked={showAllPossibleRoutes}
                />
              }
              label="Show all possible routes"
            /> */}
            {this.renderRoutes(routes)}
          </div>
        </div>
      </Modal>
    );
  }
}
